import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64d1c584")

_pushScopeId("data-v-64d1c584")
const _hoisted_1 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0",
  y: "0",
  viewBox: "0 0 52 52",
  "xml:space": "preserve"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  class: "color1",
  d: "M19 0H33V52H19z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  class: "color1",
  d: "M0 19H52V33H0z"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
})